import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import BasicObject from 'model/basicObject'
import AuditLogChangeset from 'model/tickets/auditLogs/auditLogChangeset'
import { initArray } from 'model/helpers'
import { getDateAndTimeFormat } from 'utils/helpers/dateHelper'

class AuditLog extends BasicObject {
  constructor(init) {
    super(init)
    if (isNil(init)) return undefined
    this._action = init.action
    this._created_at = init.created_at
    this._changeset = initArray(init, ['changeset'], AuditLogChangeset, {
      parent_action: init.action
    })
    this._creator = init.creator
  }

  static shape = {
    id: PropTypes.string.isRequired,
    action: PropTypes.string,
    changeset: PropTypes.array,
    creator: PropTypes.object
  }

  get action() {
    return this._action
  }

  get created_at() {
    return this._created_at
  }

  get changeset() {
    return this._changeset || []
  }

  get creator() {
    return this._creator
  }

  // Calculable
  get getCreatorName() {
    return this.creator?.full_name || 'System'
  }

  get getCreatedAt() {
    return getDateAndTimeFormat(this.created_at)
  }

  get getPriorityChanges() {
    return this.changeset.find(change => change.field === 'priority')
  }

  get getStatusChanges() {
    return this.changeset.filter(change => change.field === 'ticket_state_id')
  }

  get getAssignedChanges() {
    return this.changeset.filter(change => change.field === 'assigned_to_id')
  }

  get getAssignedChangesWithNotes() {
    return this.changeset.filter(
      change => change.field === 'assigned_to_id' && change.notes
    )
  }
}

export default AuditLog
